import styled, { css } from 'styled-components';

import Checkbox from '@components/Checkbox';

import { InputProps } from '../../InputProps';
import DefaultInput from '../Default';
import { widthMixin } from '../mixins';

type OptionalInput = { inputShown?: boolean };

const inputShownContainerMixin = ({ inputShown }: OptionalInput) =>
  inputShown
    ? null
    : css`
        display: flex;
        height: 100%;
      `;
export const Container = styled.div<InputProps & OptionalInput>`
  position: relative;
  font-family: ${({ theme }) => theme.fonts.main};
  ${widthMixin};
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -webkit-appearance: none;
    appearance: none;
  }
  ${inputShownContainerMixin}
  pointer-events: ${(p) => (p.disabled ? 'none' : 'all')};
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
`;

const inputShownCheckboxMixin = ({ inputShown }: OptionalInput) =>
  inputShown
    ? css`
        position: absolute;
        right: 0;
        margin-right: 21px;
      `
    : css`
        position: relative;
      `;

export const StyledCheckbox = styled(Checkbox)<OptionalInput>`
  top: 0;
  bottom: 0;
  ${inputShownCheckboxMixin};
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  line-height: 24px;

  & > div {
    transform: scale(0.8);
  }

  & > span {
    user-select: none;
    padding: 0px 5px;
  }
`;

type Props = {
  mode: 'active' | 'inactive';
};
// TODO: Unknown typescript error (ISSUE: GSF-1611)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore:next-line
export const InputField = styled(DefaultInput)<Props>`
  .setur-input-affix-wrapper-focused {
    box-shadow: none;
  }
`;
